import { Outlet } from "react-router-dom";
import styles from "./AccountLayout.module.scss";
import { AccountMenu } from "../AccountMenu/AccountMenu";
import { Logo } from "../Header/Header";
import { Icon } from "../SVGsprite/svgsprite";
import { AuthState } from "../../xstate/auth.machine";
import { useActor } from "@xstate/react";
import { useState, useEffect } from "react";

export function AccountLayout() {
	let [stateAuth, sendAuth] = useActor(AuthState);
	const [showPopup, setShowPopup] = useState(false);

	useEffect(() => {
		const popupShown = localStorage.getItem("authPopupShown");

		if (popupShown) {
			setShowPopup(false);
			return;
		}

		const email = stateAuth?.context?.email || stateAuth?.email || "";
		if (
			email &&
			!email.endsWith(".ru") &&
			!email.endsWith("@sportavto.com") &&
			!email.endsWith("@essmo.org") &&
			!email.endsWith("@makk.club") &&
			!email.endsWith("@zamena.org")
		) {
			setShowPopup(true);
			localStorage.setItem("authPopupShown", "true");
		} else {
			setShowPopup(false);
		}
	}, [stateAuth]);

	const handleClosePopup = () => {
		setShowPopup(false);
	};

	return (
		<main id="main" className={styles.flexContainer} role="main">
			<aside className={styles.sidebar}>
				<div className={styles.sidebarWrapper}>
					<Logo dark />
					<AccountMenu />
				</div>
			</aside>
			<section className={styles.workarea}>
				<Outlet />
				{showPopup && (
					<div className={styles.popup}>
						<div className={styles.window}>
							<h2>Изменение способов авторизации</h2>
							<p>
								С 10 июля мы вынуждены ограничить авторизацию через иностранные
								сервисы (почта Google, iCloud Mail, Outlook.com и др.).
							</p>
							<p>
								Вход на сайт будет доступен только для почтовых адресов
								на российских доменах (@mail.ru, @yandex.ru, @bk.ru,
								@inbox.ru и др.)
							</p>
							<p>
								Сменить почту можно через Обратную связь. Укажите в сообщении
								ваш текущий адрес почты и новый — мы обновим данные вручную.
							</p>
							<button
								type="button"
								className={`modalClose ` + styles.modalClose}
								style={{ marginLeft: "auto" }}
								onClick={handleClosePopup}
							>
								<Icon name="icon-close" sizeW="32" sizeH="32" />
								<span className="visuallyHidden">Закрыть</span>
							</button>
							<a
								href="/feedback"
								style={{ margin: "0 auto" }}
								type="button"
								target="_blank"
								className="btn btnPrimary btnForm"
							>
								Сменить адрес почты
							</a>
						</div>
					</div>
				)}
			</section>
		</main>
	);
}
